(function(){
'use strict';

scFundraisingPageSearchModel.$inject = ["scResourceSearchModel"];
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function scFundraisingPageSearchModel(scResourceSearchModel) {
  return function (_scResourceSearchMode) {
    _inherits(FundraisingPageSearchModel, _scResourceSearchMode);

    function FundraisingPageSearchModel(fields, queryParams) {
      _classCallCheck(this, FundraisingPageSearchModel);

      return _possibleConstructorReturn(this, (FundraisingPageSearchModel.__proto__ || Object.getPrototypeOf(FundraisingPageSearchModel)).call(this, 'fundraising-pages', fields, queryParams));
    }

    /**
     * {@inheritdoc}
     */


    _createClass(FundraisingPageSearchModel, [{
      key: 'getReadableTypeName',
      value: function getReadableTypeName() {
        return 'fundraisers';
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getLogo',
      value: function getLogo(resource) {
        return _.get(resource, 'logo.asset.src', _.get(resource, 'logo.cdn_url', '/static/global/images/individual_default_image.png'));
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getName',
      value: function getName(resource) {
        return resource.alias || resource.title;
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getDescription',
      value: function getDescription(resource) {
        return _.get(resource, 'intro_text', '').replace(/<\/?(.*?)>|&nbsp;/g, '').replace(/&amp;/g, '&');
      }
    }]);

    return FundraisingPageSearchModel;
  }(scResourceSearchModel);
}

angular.module('classy').factory('scFundraisingPageSearchModel', scFundraisingPageSearchModel);
})();